import { InboxSectionTagRecord } from "libs/schema";
import { UseRecordResult, useRecord } from "./useRecord";

export function useInboxSection(inboxSectionId?: string | null) {
  const result = useRecord("tag", inboxSectionId, { name: "useInboxSection" });
  return result as [InboxSectionTagRecord | null, UseRecordResult<"tag">[1]];
}
